// Module
var code = "<div class=\"well text-center h-100\"> <loading-spinner></loading-spinner> <div class=\"mTop10\"> <h4>Please wait while we redirect you</h4> </div> </div>";
// Exports
module.exports = code;